import request from 'sb-request'
import { reducers } from 'redux/core'
import { modifyItems as modifyQueueItems } from 'redux/models/queue/actions'


const getGQLParams = (userId) => {
  if (!userId) {
    return ''
  }

  if (/^\d+$/.test(userId)) {
    return `(userId: ${userId})`
  }

  return `(personalCode: "${userId}")`
}

const fetch = (userId) =>
  request.post('graphql?name=publicProfile', {
    body: {
      // TODO move stats inside publicProfile
      query: `{
        user: publicProfile${getGQLParams(userId)} {
          id
          firstName
          lastName
          gender
          avatar
          registrationDate
          subscription: subscriptionStatus {
            value
            statusText
            subscribed
          }
        }
        stats: profileStat${getGQLParams(userId)} {
          orders
          queue
          reviews
          ratedProducts
        }
      }`,
    },
    modifyResult: ({ user, stats }) => ({
      // TODO OMG backend sends "null" sometimes....
      user: user || {
        registrationDate: null,
        subscription: {
          statusText: null,
        },
      },
      stats: stats || {
        orders: 0,
        queue: 0,
        reviews: 0,
        ratedProducts: 0,
      },
    }),
  })
    .then(({ user, stats }) => reducers.view.profilePage.set({ user, stats }))

const fetchQueue = (userId) => {
  reducers.view.profilePage.setQueueFetching(true)

  return request.post('graphql?name=publicQueue', {
    body: {
      query: `{
        queue${getGQLParams(userId)} {
          items {
            year
            month
            status: statusName
            tracking {
              id
              trackingNumber
              trackingUrl
              shipmentDate
              status
            }
            products {
              id
              name
              brand
              image
              index
            }
          }
        }
      }`,
    },
    modifyResult: ({ queue }) => modifyQueueItems(queue),
  })
    .then(({ items }) => reducers.view.profilePage.setQueueItems(items))
}

const fetchReceivedProducts = (userId) => {
  reducers.view.profilePage.setReceivedProductsFetching(true)

  return request.post('graphql?name=productsReceived', {
    body: {
      query: `{
        items: productsReceived${getGQLParams(userId)} {
          id
          url
          name
          brand
          img
          category
          type
          rating
          labels
        }
      }`,
    },
    // TODO OMG backend sends "null" sometimes....
    modifyResult: ({ items }) => (items || []),
  })
    .then((items) => reducers.view.profilePage.setReceivedProducts(items))
}

const fetchReviews = (userId) => {
  reducers.view.profilePage.setReviewsFetching(true)

  return request.post('graphql?name=fetchReviews', {
    body: {
      query: `{
        items: userReviews${getGQLParams(userId)} {
          id
          date
          rating
          review
          skinType
          ageCategory
          isPositive
          helpful {
            positive
            negative
          }
          tags {
            id
            name
            image
            voteCount
          }
          product {
            id
            image
            url
            name
          }
        }
      }`,
    },
    // TODO OMG backend sends "null" sometimes....
    modifyResult: ({ items }) => (items || []),
  })
    .then((items) => reducers.view.profilePage.setReviews(items))
}

const fetchRatedProducts = (userId) => {
  reducers.view.profilePage.setRatedProductsFetching(true)

  return request.post('graphql?name=fetchRatedProducts', {
    body: {
      query: `{
        items: userReviews${getGQLParams(userId)} {
          product {
            id
            url
            img
            name
            type
            brand
            labels
            rating
            category
          }
          tags {
            id
            name
            image
            voteCount
          }
        }
      }`,
    },
    // TODO OMG backend sends "null" sometimes....
    modifyResult: ({ items }) => (items || []),
  })
    .then((items) => reducers.view.profilePage.setRatedProducts(items))
}


export default {
  fetch,
  fetchQueue,
  fetchReceivedProducts,
  fetchReviews,
  fetchRatedProducts,
}
